export const ROOT_PATH: {
    [key: string]: string;
} = {
    home: '/',
    auth: '/auth',
    login: '/auth/login',
    downloadKeys: '/downloadKey',
    devicePassword: '/devicePassword',
    resetPassword: '/auth/resetPassword',
};
